import { render, staticRenderFns } from "./detail - 副本.vue?vue&type=template&id=7268eb8b&scoped=true"
import script from "./detail - 副本.vue?vue&type=script&lang=js"
export * from "./detail - 副本.vue?vue&type=script&lang=js"
import style0 from "./detail - 副本.vue?vue&type=style&index=0&id=7268eb8b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7268eb8b",
  null
  
)

export default component.exports